import bytes from 'bytes';

export const FileUploadIntentVersion = 1;
export const UploadedFileMetadataVersion = 1;

export const FileType = {
  Image: 'image'
} as const;

export type FileType = (typeof FileType)[keyof typeof FileType];

export const ImageSupportedMimeTypes = [
  'image/heic',
  'image/heif',
  'image/jpeg',
  'image/png',
  'image/webp'
];

export const ImageMimeExtMap = {
  'image/heic': ['.heic', '.heif'],
  'image/heif': ['.heic', '.heif'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/webp': ['.webp']
} as const;

export const ImageSupportedExt = Object.values(ImageMimeExtMap).flat();

export const ImageFileSizeRange = {
  min: bytes('100B')!,
  max: bytes('6MB')!
};
